var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule_detail"
  }, [_c('div', {
    staticClass: "schedule-title"
  }, [_vm._v(_vm._s(this.$t("information.passenger")))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.scheduleList,
      "border": "",
      "header-cell-class-name": "header-row",
      "cell-style": {
        textAlign: 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "dates",
      "label": _vm.$t('public.date')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "times",
      "label": _vm.$t('public.time')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tips",
      "label": _vm.$t('public.tips')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "schedule-title"
  }, [_vm._v(_vm._s(this.$t("information.culture")))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.subScheduleList,
      "border": "",
      "header-cell-class-name": "header-row",
      "cell-style": {
        textAlign: 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "dates",
      "label": _vm.$t('public.date')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "times",
      "label": _vm.$t('public.time')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tips",
      "label": _vm.$t('public.tips')
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd443e6e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/scedule.vue
// module id = null
// module chunks = 